import { PortalUser, PortalUserRole } from '../model/PortalUserList.types';

const ROLE_LABELS: Record<PortalUserRole, string> = {
  1: 'Super Admin',
  2: 'Admin',
  3: 'Creator',
  4: 'Content Editor',
};

const toRoleLabel = (role: PortalUserRole): string =>
  ROLE_LABELS[role] ?? 'Unknown';

const toFullName = (user: PortalUser): string =>
  `${user.firstName} ${user.lastName}`.trim();

export type PortalUserRowVM = {
  id: number;
  fullName: string;
  email: string;
  roleLabel: string;
  isActive: boolean;
  influencerId: number | null;
  isPending: boolean;
  isDeleting: boolean;
};

export const toRowVM = (
  user: PortalUser,
  flags: { isPending: boolean; isDeleting: boolean },
): PortalUserRowVM => ({
  id: user.id,
  fullName: toFullName(user) || user.email || `Portal User #${user.id}`,
  email: user.email,
  roleLabel: toRoleLabel(user.role),
  isActive: user.isActive,
  influencerId: user.influencerId,
  isPending: flags.isPending,
  isDeleting: flags.isDeleting,
});
